import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Phone, Facebook, MessageCircle } from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import { CONTACT, SERVICES } from '../data/content';

export default function Footer() {
  const { t, lang } = useLang();
  const cn = lang === 'zh' ? 'font-cn' : '';

  return (
    <footer className="navy-gradient text-white pt-16 pb-8 relative overflow-hidden">
      <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-[#C6A15B]/10 blur-3xl" />
      <div className="max-w-7xl mx-auto px-5 lg:px-8 relative">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <div className="mb-5">
              <img src="/logo-onDark.png" alt="Zheng Da Abogados 正大律师事务所" className="h-14 w-auto object-contain" />
            </div>
            <p className={`text-white/60 text-sm leading-relaxed max-w-xs ${cn}`}>
              {t('footer.tagline')}
            </p>
            <div className="flex gap-3 mt-6">
              <a href={CONTACT.facebook} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center hover:bg-[#C6A15B] hover:border-[#C6A15B] hover:text-[#0B1F3A] transition-all">
                <Facebook className="w-4 h-4" />
              </a>
              <a href={CONTACT.whatsappLink} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center hover:bg-[#C6A15B] hover:border-[#C6A15B] hover:text-[#0B1F3A] transition-all">
                <MessageCircle className="w-4 h-4" />
              </a>
              <a href={CONTACT.wechat} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center hover:bg-[#C6A15B] hover:border-[#C6A15B] hover:text-[#0B1F3A] transition-all text-xs font-semibold">
                微信
              </a>
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h4 className={`text-sm uppercase tracking-widest text-[#C6A15B] mb-5 ${cn}`}>{t('footer.quickLinks')}</h4>
            <ul className="space-y-3">
              {[['/', t('nav.home')], ['/quienes-somos', t('nav.about')], ['/servicios', t('nav.services')], ['/contacto', t('nav.contact')]].map(([to, label]) => (
                <li key={to}>
                  <Link to={to} className={`text-white/65 hover:text-white text-sm transition-colors ${cn}`}>{label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className={`text-sm uppercase tracking-widest text-[#C6A15B] mb-5 ${cn}`}>{t('footer.servicesTitle')}</h4>
            <ul className="space-y-3">
              {SERVICES.slice(0, 6).map((s) => (
                <li key={s.slug}>
                  <Link to={`/servicios/${s.slug}`} className={`text-white/65 hover:text-white text-sm transition-colors ${cn}`}>{s[lang].title}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className={`text-sm uppercase tracking-widest text-[#C6A15B] mb-5 ${cn}`}>{t('footer.contactTitle')}</h4>
            <ul className="space-y-4 text-sm text-white/65">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#C6A15B] mt-0.5 shrink-0" />
                <span>{CONTACT.addressLine1}<br />{CONTACT.addressLine2}</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-[#C6A15B] shrink-0" />
                <a href={`mailto:${CONTACT.email}`} className="hover:text-white transition-colors">{CONTACT.email}</a>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-[#C6A15B] shrink-0" />
                <a href={CONTACT.whatsappLink} className="hover:text-white transition-colors">{CONTACT.whatsapp}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-white/50 text-xs">© {new Date().getFullYear()} Zheng Da Abogados SL. {t('footer.rights')}.</p>
          <p className="text-white/50 text-xs hover:text-white/80 cursor-pointer transition-colors">{t('footer.privacy')}</p>
        </div>
      </div>
    </footer>
  );
}
